// Tiny rendering helpers shared by screens. We build HTML strings (typed in
// functions) and wire jQuery handlers after injection — no framework.

/** Escape untrusted text for safe interpolation into HTML. */
export function esc(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Join class names, dropping falsy values. */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(' ');
}

/** An avatar element: uses the image with an initials fallback background. */
export function avatarHtml(name: string, url: string, size = 40): string {
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return `<span class="avatar" style="width:${size}px;height:${size}px;font-size:${Math.round(
    size / 2.6,
  )}px">
    <img src="${esc(url)}" alt="" loading="lazy" onerror="this.style.display='none'" />
    <span class="avatar__initials">${esc(initials)}</span>
  </span>`;
}
